export default "__VITE_ASSET__CvVQ$blf__"